import React from 'react';

import { ResizableModal, ModalPosition } from 'ui/components/styled';
import { EmailPreview } from 'ui/components/shared';

export const EmailModal = ({
  email,
  onClose,
  minHeight = '600px',
  bodyHeight: initialBodyHeight = '500px',
  ...rest
}) => {
  const ref = React.useRef();
  const [bodyHeight, setBodyHeight] = React.useState(initialBodyHeight);
  const heightDiff = React.useMemo(() => (email?.headerLines ? 175 : 153), [email]); // height difference between modal & email preview body

  const handleResize = (event, direction, refToElement) => {
    const rect = refToElement.getBoundingClientRect();
    const height = rect.height - heightDiff;
    setBodyHeight(`${height}px`);
  };

  const handleResizeStop = (event, direction, refToElement) => {
    // reset height to auto, to avoid overflow issue when toggling email headers collapse
    refToElement.style.height = 'auto';
  };

  const handleBodyWidthInit = (width) => {
    // set modal width to be the same as email body width to avoid large headers text taking full screen width issue
    ref.current.style.width = `${Math.floor(width) + 40}px`; // 40 == padding left + right
  };

  return (
    <ResizableModal
      ref={ref}
      padding="1rem"
      onClose={onClose}
      position={ModalPosition.TOP_CENTER}
      top="10%"
      width="auto"
      height="auto"
      minWidth="40%"
      minHeight={minHeight}
      enable={{
        right: true,
        left: true,
        bottom: true,
        bottomRight: true,
        bottomLeft: true,
      }}
      onResize={handleResize}
      onResizeStop={handleResizeStop}
      {...rest}
    >
      {email && (
        <EmailPreview
          email={email}
          maxBodyHeight={bodyHeight}
          onBodyWidthInit={handleBodyWidthInit}
          onClose={onClose}
          closable
        />
      )}
    </ResizableModal>
  );
};
